/* eslint-disabled */

export default class ItemGuaranteeExtend {


  constructor (object?: any) {
  }

}
